import { useLocalStorage } from "@vueuse/core";
import { useUlid } from "~/composables/useUlid.js";

export function useNetworkOutage() {
  const ulid = useUlid();

  const state = useLocalStorage("network_outage", {
    count: 0,
    start: null,
    end: null,
    id: null,
  });

  function log() {
    if (!state.value.id) {
      return start();
    }

    state.value.count = (state.value.count || 0) + 1;

    state.value.end = new Date().toISOString();
  }

  function start() {
    state.value = {
      count: 1,
      start: new Date().toISOString(),
      end: new Date().toISOString(),
      id: ulid.make(),
    };
  }

  function clear() {
    state.value.count = 0;
    state.value.start = "";
    state.value.end = "";
    state.value.id = "";
  }

  function attachHeaders(headers) {
    if (!state.value.id) {
      return;
    }

    headers.set("Network-Outage-Count", state.value.count);

    headers.set("Network-Outage-Start", state.value.start);

    headers.set("Network-Outage-End", state.value.end);

    headers.set("Network-Outage-Id", state.value.id);
  }

  return {
    log,
    clear,
    attachHeaders,
  };
}
